import { apiClient } from './axios';

import type {
  TelnyxAssignInboundNumberDto,
  TelnyxNumberSyncResponse,
  TelnyxPhoneNumber,
} from '@repo/shared-types';

export const telnyxNumbersApi = {
  list: async (): Promise<TelnyxPhoneNumber[]> => {
    const response = await apiClient.get<TelnyxPhoneNumber[]>('/telnyx/numbers');
    return response.data;
  },

  sync: async (): Promise<TelnyxNumberSyncResponse> => {
    const response = await apiClient.post<TelnyxNumberSyncResponse>('/telnyx/numbers/sync');
    return response.data;
  },

  assignInbound: async (
    numberId: string,
    payload: TelnyxAssignInboundNumberDto,
  ): Promise<TelnyxPhoneNumber> => {
    const response = await apiClient.patch<TelnyxPhoneNumber>(
      `/telnyx/numbers/${numberId}/assign-inbound`,
      payload,
    );
    return response.data;
  },
};
